import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./ErrorBoundary";
import { waitForSdk } from "./telegram/tg";
import "./styles.css";

// Глобальный перехват — если что-то падает вне React-рендера (напр. в boot),
// покажем текст вместо белого экрана.
function showFatal(msg: string) {
  const root = document.getElementById("root");
  if (root && !root.dataset.crashed) {
    root.dataset.crashed = "1";
    root.innerHTML =
      '<div style="padding:16px;font-family:monospace;font-size:12px;color:#ffb4b4;background:#1a0d0d;min-height:100dvh;white-space:pre-wrap;word-break:break-word">⚠️ Ошибка\n' +
      msg.replace(/</g, "&lt;") +
      "</div>";
  }
}
window.addEventListener("error", (e) => showFatal(String(e.message || e.error)));
window.addEventListener("unhandledrejection", (e) => showFatal("unhandledrejection: " + String(e.reason)));

// Ждём готовности SDK мессенджера (initData), затем рендерим — иначе при async-загрузке
// telegram-web-app.js приложение стартует как «веб» и зря спрашивает телефон.
void waitForSdk().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
});
